import http from '../utils/request'

/**
 * 认证相关接口
 * 对应后端 BPMService AuthController (/api/auth)
 */

// 获取可登录的账套（租户）列表，可选传入账号过滤
export const getTenants = (account) => {
  const params = account ? { account } : {}
  return http.get('/auth/tenants', { params })
}

// 登录：{ tenantId, account, password }
export const login = (data) => http.post('/auth/login', data)

// 获取当前登录用户档案
export const getProfile = () => http.get('/auth/profile')
